import { hasNonEmptyLabel, isVideoInputDevice } from "../selectors";

export function checkHasVideoInputPermissions(
  devices: MediaDeviceInfo[],
): boolean {
  const videoInputDevices = devices.filter(isVideoInputDevice);

  if (videoInputDevices.length === 0) return false;

  return videoInputDevices.every(hasNonEmptyLabel);
}
